import { defineLocale } from "../../registry";

const partnerLink = defineLocale({
  ru: {
    "partnerLink.title": "Партнёрская ссылка",
    "partnerLink.option.title": "Опция {n}",
    "partnerLink.empty":
      "У этого Pick нет опций Book или Enquire, к которым можно привязать ссылку",
    "partnerLink.url.label": "Целевой URL",
    "partnerLink.url.rules":
      "Только HTTPS, без логина и пароля, без IP-адреса и localhost, порт 443, хост из разрешённых хостов партнёра",
    "partnerLink.partner.label": "Партнёр",
    "partnerLink.partner.none": "Без партнёра",
    "partnerLink.partner.loading": "Партнёры загружаются…",
    "partnerLink.partner.unavailable": "Не удалось загрузить партнёров",
    "partnerLink.partner.unknown": "Партнёр {id}",
    "partnerLink.open": "Открыть ссылку",
    "partnerLink.hint.malformed": "Это не похоже на веб-адрес",
    "partnerLink.hint.not_https": "Принимаются только адреса HTTPS",
    "partnerLink.hint.credentials": "Уберите логин и пароль из адреса",
    "partnerLink.hint.ip_address": "Нужно имя хоста, а не IP-адрес",
    "partnerLink.hint.localhost": "localhost не принимается",
    "partnerLink.hint.port": "Допустим только порт 443",
    "partnerLink.hint.host_not_allowed":
      "Хоста нет среди разрешённых хостов партнёра",
    "partnerLink.error.not_https": "Адрес должен начинаться с HTTPS",
    "partnerLink.error.userinfo": "В адресе не должно быть логина и пароля",
    "partnerLink.error.ip_address": "Адрес не должен быть IP-адресом",
    "partnerLink.error.localhost": "Адрес не должен указывать на localhost",
    "partnerLink.error.lookalike": "Хост лишь похож на разрешённый",
    "partnerLink.error.host_not_allowed":
      "Хоста нет в списке разрешённых хостов партнёра",
    "partnerLink.error.generic":
      "Адрес не принят: нужен HTTPS, без логина и пароля, без IP-адреса и localhost, порт 443 и хост из списка партнёра",
    "partnerLink.check.title": "Проверка ссылки",
    "partnerLink.check.checkedAt": "проверено {at}",
    "partnerLink.check.source.manual": "вручную",
    "partnerLink.check.source.auto": "автоматически",
    "partnerLink.check.source.unknown": "источник неизвестен",
    "partnerLink.check.alive": "Подтвердить: ссылка работает",
    "partnerLink.check.dead": "Подтвердить: ссылка не работает",
    "partnerLink.check.pending":
      "Сохраните новый адрес или партнёра: после этого ссылку можно подтвердить заново",
    "partnerLink.check.noAddress":
      "Сначала сохраните целевой URL: подтверждать пока нечего",
  },
  en: {
    "partnerLink.title": "Partner link",
    "partnerLink.option.title": "Option {n}",
    "partnerLink.empty":
      "This Pick has no Book or Enquire option to attach a link to",
    "partnerLink.url.label": "Target URL",
    "partnerLink.url.rules":
      "Only HTTPS, no login or password, no IP address or localhost, port 443, a host from the partner's allowed hosts",
    "partnerLink.partner.label": "Partner",
    "partnerLink.partner.none": "No partner",
    "partnerLink.partner.loading": "Loading partners…",
    "partnerLink.partner.unavailable": "Partners could not be loaded",
    "partnerLink.partner.unknown": "Partner {id}",
    "partnerLink.open": "Open link",
    "partnerLink.hint.malformed": "This does not look like a web address",
    "partnerLink.hint.not_https": "Only HTTPS addresses are accepted",
    "partnerLink.hint.credentials": "Remove the login and password from the address",
    "partnerLink.hint.ip_address": "Use a host name, not an IP address",
    "partnerLink.hint.localhost": "localhost is not accepted",
    "partnerLink.hint.port": "Only port 443 is accepted",
    "partnerLink.hint.host_not_allowed":
      "The host is not among the partner's allowed hosts",
    "partnerLink.error.not_https": "The address must use HTTPS",
    "partnerLink.error.userinfo":
      "The address must not contain a login or password",
    "partnerLink.error.ip_address": "The address must not be an IP address",
    "partnerLink.error.localhost": "The address must not point to localhost",
    "partnerLink.error.lookalike": "The host only looks like an allowed one",
    "partnerLink.error.host_not_allowed":
      "The host is not on the partner's allowed list",
    "partnerLink.error.generic":
      "This address was not accepted: use HTTPS, no login or password, no IP address or localhost, port 443 and a host the partner allows",
    "partnerLink.check.title": "Link check",
    "partnerLink.check.checkedAt": "checked {at}",
    "partnerLink.check.source.manual": "manually",
    "partnerLink.check.source.auto": "automatically",
    "partnerLink.check.source.unknown": "source unknown",
    "partnerLink.check.alive": "Confirm link as working",
    "partnerLink.check.dead": "Confirm link as dead",
    "partnerLink.check.pending":
      "Save the new address or partner, then the link can be confirmed again",
    "partnerLink.check.noAddress":
      "Save a target URL first: there is nothing to confirm yet",
  },
});

export default partnerLink;
